import { onAuthStateChanged } from "firebase/auth";
import React, { useContext } from "react";
import { useState } from "react";
import { useLayoutEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { auth2 } from "../../../firebase";
import Logo from "../Assets/Logo";
import Sidebar from "../SidebarBackLink/SidebarBackLink";
import KeyboardArrowDownIcon from "../Assets/KeyboardArrowDownIcon";
import KeyboardArrowUpIcon from "../Assets/KeyboardArrowUpIcon";
import "./Style.css";
import { userAuthContext } from "../../../contextApi/backlink/useAuthContext";
import favicon from "../Assets/Favicon.png";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { getWorkSpaceData } from "../../../store/actions/userData/WorkspaceData";
import TipLoader from "../../utils/TipLoader/TipLoader";
// import Linkcontext from "../../../contextApi/backlink/Linkcontext";

function Landing() {
  const [showLogout, setShowLogout] = useState(false);
  const { logOut } = useContext(userAuthContext);
  // const { clearContext } = useContext(Linkcontext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);
  const [tipLoader, setTipLoader] = useState(true);
  const { workspace } = useSelector((data) => data.userData);

  const handleLogout = async () => {
    try {
      localStorage?.clear();
      sessionStorage.clear();
      await logOut();
      // await clearContext();
      return navigate("/backlink/login", {
        state: {
          logout: true,
        },
      });
    } catch (error) {}
  };

  const Header = () => {
    return (
      <div className="header">
        <div className="logoDiv" onClick={() => navigate("/backlink")}>
          <Logo />
          <span className="heading">BackLink Monitor</span>
        </div>
        <div className="userDiv">
          <div>
            {localStorage?.getItem("name") !== "null" && (
              <p className="userName">{localStorage?.getItem("name")}</p>
            )}
            <p className="userSite">{localStorage?.getItem("email")}</p>
          </div>
          {localStorage?.getItem("imgurl") !== "null" ? (
            <img
              className="userImage"
              src={localStorage?.getItem("imgurl")}
              alt="profilePic"
            />
          ) : (
            <p className="profileImg">
              {localStorage?.getItem("email").charAt(0, 1)}
            </p>
          )}

          <button
            className="toggleButton"
            onClick={() => {
              setShowLogout(!showLogout);
            }}
          >
            {showLogout ? (
              <KeyboardArrowUpIcon color="#5541D7" />
            ) : (
              <KeyboardArrowDownIcon color="#5541D7" />
            )}
          </button>
          {showLogout && (
            <div className="showLogoutContainer">
              <div className="element_hover">
                <div
                  style={{
                    fontSize: "13px",
                    padding: "5px 0 0 5px",
                    marginBottom: "0.2rem",
                  }}
                >
                  Your workspaces
                </div>
                <div
                  onClick={() => {
                    localStorage.removeItem("workspaceId");
                    window.location.reload();
                  }}
                  style={{ padding: "5px", borderBottom: "1px solid" }}
                >
                  My Workspace (Owner){" "}
                </div>
              </div>

              {workspace?.map((ele) => (
                <div
                  className={
                    localStorage.getItem("workspaceId") === ele.ownerId
                      ? " element_hover  element_hover_select"
                      : " element_hover "
                  }
                  onClick={() => {
                    localStorage.setItem("workspaceId", ele.ownerId);
                    window.location.reload();
                  }}
                  style={{ padding: "5px" }}
                >
                  {console.log(
                    localStorage.getItem("workspaceId") === ele.ownerId,
                  )}
                  {ele.name}'s Workspace
                </div>
              ))}

              <div
                style={{
                  padding: "5px",
                  textAlign: "right",
                  borderTop: "1px solid",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  handleLogout();
                }}
                className="element_hover"
              >
                Log Out
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  useLayoutEffect(() => {
    onAuthStateChanged(auth2, async (current) => {
      console.log("Run again");
      if (!current) {
        const gotoRoute = window.location.href.split("/backlink")[1];
        if (gotoRoute.includes("pricing?")) {
          localStorage.setItem("gotoRoute", gotoRoute);
        }
        navigate("/backlink/login", {
          state: { location: window.location.pathname },
        });
        setLoading(false);
      } else {
        const token = await current.getIdToken(true);
        localStorage.setItem("backlink_token", token);
        localStorage.setItem("name", current?.displayName);
        localStorage.setItem("email", current?.email);
        localStorage.setItem("imgurl", current?.photoURL);
        dispatch(getWorkSpaceData("backlink"));
        setLoading(true);
      }
    });
  }, []);
  return (
    <>
      <Helmet>
        <title>Links - Backlink Monitor</title>
        <meta
          name="description"
          content="Use backlink monitor to keep checking your backlinks & ensure they are not removed. After all, you paid for them with money, time or effort. Whenever you create a backlink, add it to Backlink Monitor to get notified if it is removed or edited and take necessary action proactively"
        />
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        <meta property="og:title" content="Links - Backlink Checker" />
        <meta
          property="og:description"
          content="Use backlink monitor to keep checking your backlinks & ensure they are not removed. After all, you paid for them with money, time or effort. Whenever you create a backlink, add it to Backlink Monitor to get notified if it is removed or edited and take necessary action proactively"
        />
        <meta name="twitter:card" content={"/og_backLink.jpg"} />
      </Helmet>
      <div className="backLink">
        {Loading && (
          <>
            <Header />
            <div className="backLinkContainer">
              <div className="sidebar">
                <Sidebar />
              </div>
              <div className="mainContainer">
                <Outlet />
              </div>
            </div>
          </>
        )}
        {tipLoader && <TipLoader setTipLoader={setTipLoader} time={3500} />}
      </div>
    </>
  );
}

export default Landing;
